// components/CkEditorField.js
import React from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const CkEditorField = ({ label, name, value, handleChange, uploadPlugin }) => {
    return (
        <div className="col-md-12">
            <label htmlFor={name} className="col-form-label">
                <span style={{ color: "red" }}>*</span> {label} :
            </label>
            <CKEditor
                editor={ClassicEditor}
                data={value}
                onChange={(event, editor) => handleChange(name, editor)}
                config={{ extraPlugins: [uploadPlugin] }}
                onInit={(editor) => uploadPlugin(editor)}
            />
        </div>
    );
};

export default CkEditorField;
